import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import uzTranslation from './uz/translation.json';
import enTranslation from './en/translation.json';
import ruTranslation from './ru/translation.json';

const resources = {
  uz: {
    translation: uzTranslation,
  },
  en: {
    translation: enTranslation,
  },
  ru: {
    translation: ruTranslation,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'uz',
    fallbackLng: 'uz',
    supportedLngs: ['uz', 'en', 'ru'],
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
